module.exports = __webpack_public_path__ + "7778a5fbdf8ef520cd7d4be63225b97c.MP3";